import { useContextSelector } from 'use-context-selector';
import EntityMentionContextProvider from './context';
import { type EntityMentionContext as EntityMentionContextType } from './types';

function useEntityMentionContext<Selected>(
    selector: (value: EntityMentionContextType) => Selected,
) {
    return useContextSelector(EntityMentionContextProvider, (context) => {
        if (context === undefined) {
            throw new Error(
                'useEntityMentionContext must be used within a EntityMentionProvider',
            );
        }
        return selector(context);
    });
}

export default useEntityMentionContext;
